export default __webpack_public_path__ + "static/1212-ab10551fd3df7ee759780284bb62bff8.gif";